// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__jQcWe","control":"Auth_control__MbNfJ"};